"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { BRAND, BRAND_BG } from "@/lib/constants";

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

// global-error replaces the root layout, so it must render its own <html>/<body>
// and cannot rely on the app's stylesheet — keep all styling inline.
export default function GlobalError({ error, reset }: Props) {
  useEffect(() => {
    posthog.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100dvh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "1.5rem",
          background: BRAND_BG,
          color: BRAND,
          fontFamily:
            "var(--font-geist-sans), system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
        }}
      >
        <div style={{ maxWidth: "26rem", textAlign: "center" }}>
          <h1
            style={{
              margin: "0 0 0.75rem",
              fontSize: "1.75rem",
              fontWeight: 700,
              letterSpacing: "-0.02em",
            }}
          >
            Something went wrong
          </h1>
          <p
            style={{
              margin: "0 0 2.5rem",
              fontSize: "0.875rem",
              lineHeight: 1.6,
              color: "rgba(255,255,255,0.6)",
            }}
          >
            The page ran into an unexpected error. Reloading usually fixes it.
          </p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              background: BRAND,
              color: BRAND_BG,
              fontWeight: 600,
              fontSize: "0.875rem",
              border: "none",
              borderRadius: "0.5rem",
              padding: "0.7rem 1.8rem",
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
